import { AfterContentInit, AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AudioServiceService } from '../audio-service.service';
import { LeaderBoardService } from '../leader-board/leaderBoardService.service';
import { MatchGameService } from '../match-game/matchGameService.service';
import { TimerService } from '../timer/timerService.service';

@Component({
  selector: 'app-game-info',
  templateUrl: './game-info.component.html',
  styleUrls: ['./game-info.component.scss']
})
export class GameInfoComponent implements OnInit, AfterViewInit {

  // @Input() game = {
  //   name: '',
  //   info: '',
  //   kind: ''
  // }
  @Input() game;
  info = {
    match_nosaim: {
      text: 'בכל שלב תקבלו מספר תחנות, אותם תצטרכו להתאים במפה למיקום הנכון. בכל שלב מספר התחנות שיש להתאים יגדל והרמה תיהיה יותר קשה, היזהרו ישנן תחנות שלא מתאימות למפה!. <br> לרשותכם 3 פסילות כאשר התאמה לא נכונה של תחנה תיקח ממכם פסילה אחת, התאמה נכונה תעניק לכם נקודות יחסית למהירות שלקח לכם להתאים. <br> שימו לב תשובות נכונות ברצף יוצרים קומבו ולכן מעניקות יותר נקודות! <br> לאחר מספר שלבים ייפתחו גלגלי ההצלה השתמשו בהם בחכמה!',
      help1: '<span style="text-decoration: underline; font-weight: 500; font-size: 26px">גלגל הצלה מפה</span> - מפה מלאה תיפתח למשך 2 שניות!',
      help2: '<span style="text-decoration: underline; font-weight: 500; font-size: 26px">גלגל הצלה תחנות</span> - תחנות לא מתאימות ייעלמו!'
    },
    // match_mitanim: " 222222222התחנות לסיבוב אחד. גלגלי ההצלה מתחדשים בכל שלב הבאים: צפייה במפה למספר שניות או לקבל את צבעי המסלול, השחקן יכול להיעזר בגלגלי ההצלה על ידי מענה מהיר של התחנות במפה. בכל שלב יש לשחקן שלוש פסילות. גג/'ג/'ג/'ג/'מג/ך'קיק/ךלח/'יק /'ק ךל/'קח ך/'לק ח/'ק /קךלקח/'ךקלח   קךל/'חק",
    // trivia_mitanim: "1111111111התחנות לסיבוב אחד. גלגלי ההצלה מתחדשים בכל שלב הבאים: צפייה במפה למספר שניות או לקבל את צבעי המסלול, השחקן יכול להיעזר בגלגלי ההצלה על ידי מענה מהיר של התחנות במפה. בכל שלב יש לשחקן שלוש פסילות. גג/'ג/'ג/'ג/'מג/ך'קיק/ךלח/'יק /'ק ךל/'קח ך/'לק ח/'ק /קךלקח/'ךקלח קךל/'חק",
    trivia_nosaim: {
      text: 'בכל שלב תקבלו שאלה חדשה, עליכם לענות על השאלה תוך 60 שניות, ככל שתענו יותר מהר כך תקבלו יותר נקודות! <br> לרשותכם 3 פסילות כאשר תשובה לא נכונה לשאלה תוריד לכם פסילה אחת. <br> קיימות מספר תחנות שבהן תוכלו להחליף מסלול ובכך לעבור לשאלות בעלות דרגת קושי אחרת: <br> המסלול <span style="color: #ff53cf">הורוד</span> יעניק לכם מקסימום של 1000 נקודות לשאלה <br> המסלול <span style="color: #55fb99">הירוק</span> יעניק לכם מקסימום של 2000 נקודות לשאלה <br> המסלול <span style="color: #ffa44b">הכתום</span> יעניק לכם מקסימום של 3000 נקודות לשאלה <br> המסלול <span style="color: #ef1926">האדום</span> יעניק לכם מקסימום של 4000 נקודות לשאלה <br> לרשותכם 2 גלגלי הצלה השתמשו בהם בחכמה!',
      help1: '<span style="text-decoration: underline; font-weight: 500; font-size: 26px">גלגל הצלה החלף שאלה</span> - השאלה תוחלף בשאלה חדשה באותה דרגת קושי!',
      help2: '<span style="text-decoration: underline; font-weight: 500; font-size: 26px">גלגל הצלה 50:50</span> - 2 תשובות ייעלמו!'
    }
  }

  @Output() gameInfoOpen = new EventEmitter<boolean>();

  mapIsOpen = false;
  countDown = false;

  constructor(private audioService: AudioServiceService, private leaderBoardService: LeaderBoardService, private timerService: TimerService, private matchGameService: MatchGameService) { }

  ngOnInit(): void {
    this.game.info = this.info[this.game.name];
    this.leaderBoardService.setBoardIndex(this.game.name);
  }

  ngAfterViewInit() {
    document.getElementById('info_text').innerHTML = this.game.info.text;
    document.getElementById('info_text_help1').innerHTML = this.game.info.help1;
    document.getElementById('info_text_help2').innerHTML = this.game.info.help2;
  }

  onOpenMap() {
    this.mapIsOpen = true;
    this.audioService.playAudio('openMap');
  }

  onCloseMap() {
    this.audioService.playAudio('closeMap');
    let map = document.getElementById('mapCont');
    let backdrop = document.getElementById('backdrop');
    // map.style.animation = 'scale-out-pop 0.7s forwards';
    map.classList.remove('scale-in-pop');
    backdrop.classList.remove('go-in');
    map.classList.add('scale-out-pop');
    backdrop.classList.add('go-out');
    setTimeout(() => {
      this.mapIsOpen = false;
    }, 700);
  }

  onStartGame() {
    this.countDown = true;
    setTimeout(() => {
      this.countDown = false;
      this.gameInfoOpen.emit(false);
      if (this.game.kind == "match") {
        // this.timerService.startTimer();
        this.matchGameService.startGame();
      }
    }, 500);
  }
}
